import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { PersonSearch } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";
import useHandleConnected from "./useHandleConnected";

const HANDLES = [
  { id: "success", color: "#4caf50", label: "Encontrado" },
  { id: "not_found", color: "#ff9800", label: "Nao encontrado" },
  { id: "error", color: "#f44336", label: "Erro" },
];

const IxcBuscarClienteNode = memo(({ id, data, isConnectable, selected }) => {
  const getHandleClass = useHandleConnected(id);
  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<PersonSearch />}
      title="IXC: Buscar Cliente"
      color="#1a237e"
      bgColor="#EEF0FF"
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={240}
    >
      {/* Variable chip */}
      {data?.cpfCnpjVariable && (
        <div style={{ marginBottom: 6 }}>
          <span style={{ fontSize: 9, color: "#888", display: "block", marginBottom: 2 }}>
            Variavel CPF/CNPJ
          </span>
          <span style={{
            display: "inline-block",
            fontFamily: "'Fira Mono', 'Consolas', monospace",
            fontSize: 11, background: "#1a237e15", color: "#1a237e",
            borderRadius: 6, padding: "2px 8px", border: "1px solid #1a237e25",
          }}>
            {data.cpfCnpjVariable}
          </span>
        </div>
      )}

      {/* Handle rows at node edge */}
      <div style={{ display: "flex", flexDirection: "column", gap: 4, marginTop: 4 }}>
        {HANDLES.map((h) => (
          <div key={h.id} style={{
            display: "flex", alignItems: "center", justifyContent: "flex-end",
            gap: 6, position: "relative", paddingRight: 4,
          }}>
            <span style={{
              fontSize: 9, fontWeight: 600, color: "#fff",
              background: h.color, borderRadius: 10,
              padding: "1px 8px", lineHeight: "16px", whiteSpace: "nowrap",
            }}>
              {h.label}
            </span>
            <Handle
              type="source" position={Position.Right} id={h.id}
              className={getHandleClass("source", h.id)}
              style={{
                position: "absolute", top: "50%", right: -13,
                transform: "translateY(-50%)",
                cursor: "crosshair",
              }}
              isConnectable={isConnectable}
            />
          </div>
        ))}
      </div>
    </NodeWrapper>
  );
});

IxcBuscarClienteNode.displayName = "IxcBuscarClienteNode";
export default IxcBuscarClienteNode;
